import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useIsMobile } from '@scramble/hooks';
import { Button } from '@scramble/ui';
import IconRemove from './featured-icon.svg';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

const id = MODAL_IDS.bank_account_add_warning_modal;

export const BankAccountAddWarningModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

export const Modal = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const onClose = () => {
    closeModal(id);
  };

  const onAdd = () => {
    navigate(`${APP_LINKS.bankAccounts}?create=true`);
    closeModal(id);
  };

  const content = (
    <div className={s.modal}>
      <div className={s.content}>
        <img src={IconRemove} alt="icon" width={56} height={56} />
        <div className={s.title}>
          {t('bank_accounts:bank_acc_add_warn_modal.title')}
        </div>
        <div className={s.desc}>
          {t('bank_accounts:bank_acc_add_warn_modal.desc')}
        </div>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="tonal"
          size="lg"
          label={t('bank_accounts:bank_acc_add_warn_modal.not_now')}
          onClick={onClose}
        />
        <Button
          theme="neutral"
          appearance="filled"
          size="lg"
          label={t('bank_accounts:bank_acc_add_warn_modal.add')}
          onClick={onAdd}
        />
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalCenterLayout>
  );
};
